module.exports = __webpack_public_path__ + "img/MapThumb_Highlands.6e8817c7.webp";